import Preview from './src/preview.vue';

Preview.install = (App) => {
    App.component(Preview.name, Preview)
};

export default Preview;
